import type { 
  GetDomainsManagementPlatformBettingDomainsCountData,
  GetDomainsManagementPlatformBettingDomainsCountResponse,

  GetDomainsManagementPlatformBettingDomainsData,
  GetDomainsManagementPlatformBettingDomainsResponse,

  PostDomainsManagementPlatformBettingDomainsData,
  PostDomainsManagementPlatformBettingDomainsResponse,

  GetDomainsManagementPlatformBettingDomainsByIdData,
  GetDomainsManagementPlatformBettingDomainsByIdResponse,

  PutDomainsManagementPlatformBettingDomainsByIdData,
  PutDomainsManagementPlatformBettingDomainsByIdResponse,

  DeleteDomainsManagementPlatformBettingDomainsByIdData,
  DeleteDomainsManagementPlatformBettingDomainsByIdResponse
} from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";

export function getPlatformBettingDomainsApiModule(affiliatesApi: AxiosInstance) {
  return {
    /**
     * Get Platform betting domains count
     *
     * @param {Object} params
     * @param {String} [params.search]
     * @param {String} [params.affiliate_id]
     *
     * @return {Promise<Object>} api response
     */
    getPlatformBettingDomainCount(params: GetDomainsManagementPlatformBettingDomainsCountData['query']) {
      return affiliatesApi.get<GetDomainsManagementPlatformBettingDomainsCountResponse>(
        '/domains-management/platform-betting-domains/count',
        { params },
      );
    },

    /**
     * Get Platform betting domains
     *
     * @param {Object} params
     * @param {String} [params.sort_column]
     * @param {String} [params.sort_dir]
     * @param {String} [params.search]
     * @param {String} [params.affiliate_id]
     * @param {Number} [params.limit]
     * @param {Number} [params.offset]
     *
     * @return {Promise<Object>} api response
     */
    getPlatformBettingDomain(params: GetDomainsManagementPlatformBettingDomainsData['query']) {
      return affiliatesApi.get<GetDomainsManagementPlatformBettingDomainsResponse>(
        '/domains-management/platform-betting-domains',
        { params },
      );
    },

    /**
     * Create Platform betting domains
     *
     * @param {Object} data
     * @param {String} data.domain_name
     * @param {String} data.affiliate_offer_id
     *
     * @return {Promise<Object>} api response
     */
    createPlatformBettingDomain(data: PostDomainsManagementPlatformBettingDomainsData['body']) {
      return affiliatesApi.post<PostDomainsManagementPlatformBettingDomainsResponse>(
        '/domains-management/platform-betting-domains',
        data,
      );
    },

    /**
     * Get Platform betting domains by id
     *
     * @param {String} id
     *
     * @return {Promise<Object>} api response
     */
    getPlatformBettingDomainById(id: string) {
      return affiliatesApi.get<GetDomainsManagementPlatformBettingDomainsByIdResponse>(
        `/domains-management/platform-betting-domains/${id}`,
      );
    },

    /**
     * Update Platform betting domains
     *
     * @param {String} id
     * @param {Object} data
     * @param {String} data.affiliate_offer_id
     *
     * @return {Promise<Object>} api response
     */
    updatePlatformBettingDomain(id: string, data: PutDomainsManagementPlatformBettingDomainsByIdData['body']) {
      return affiliatesApi.put<PutDomainsManagementPlatformBettingDomainsByIdResponse>(
        `/domains-management/platform-betting-domains/${id}`,
        data,
      );
    },

    /**
     * Delete Platform betting domains by id
     *
     * @param {String} id
     *
     * @return {Promise<Object>} api response
     */
    deletePlatformBettingDomain(id: string) {
      return affiliatesApi.delete<DeleteDomainsManagementPlatformBettingDomainsByIdResponse>(
        `/domains-management/platform-betting-domains/${id}`,
      );
    },
  }
}